import { Component, OnInit, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
 
 
@Component({
  selector: 'app-document-viewer',
  templateUrl: './document-viewer.component.html',
  styleUrls: ['./document-viewer.component.css']
})
export class DocumentViewerComponent implements OnInit {
  form:any;
  invoice_id="";
  loaded=false;
  url:any="admin/inspection-schduled";
  url1;
  titleDoc="Document Download/View";
  isDoc=true;
  constructor(public dialogRef: MatDialogRef<DocumentViewerComponent>,
    private dom:DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data
 
     ) { 
     
      let url;
      
      if(typeof data=="object"){
        url=data.url;
        this.isDoc=false;
       
        if(data && data.title)
          this.titleDoc=data.title;
      }
      else{
        url=data;
      }
        
        
      // this.sanitizer.bypassSecurityTrustUrl(this.mediaItems[1].url);
      this.data=url;
       
      // this.url=this.dom.bypassSecurityTrustResourceUrl("https://view.officeapps.live.com/op/embed.aspx?src="+data+"&embedded=true"); 
      this.url1=this.dom.bypassSecurityTrustResourceUrl( url); 
     
    }

  ngOnInit() { 
    
  }
  myLoadEvent(){
    this.loaded=true;

  }
  getErrorMessage(name) { 
   
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  loading=false;
  submit()
  {
    window.open(this.data);
   }
  
}
